__turbopack_export_value__({
  "arrow": "accordion-module-scss-module__GoEIuG__arrow",
  "arrow__opened": "accordion-module-scss-module__GoEIuG__arrow__opened",
  "body-logo-18": "accordion-module-scss-module__GoEIuG__body-logo-18",
  "body-text-12": "accordion-module-scss-module__GoEIuG__body-text-12",
  "body-text-14": "accordion-module-scss-module__GoEIuG__body-text-14",
  "body-text-16": "accordion-module-scss-module__GoEIuG__body-text-16",
  "body-text-18": "accordion-module-scss-module__GoEIuG__body-text-18",
  "body-text-20": "accordion-module-scss-module__GoEIuG__body-text-20",
  "body-text-24": "accordion-module-scss-module__GoEIuG__body-text-24",
  "body-text-24-2": "accordion-module-scss-module__GoEIuG__body-text-24-2",
  "body-text-heading-2": "accordion-module-scss-module__GoEIuG__body-text-heading-2",
  "body-text-heading-3": "accordion-module-scss-module__GoEIuG__body-text-heading-3",
  "body-text-medium-14": "accordion-module-scss-module__GoEIuG__body-text-medium-14",
  "body-text-medium-16": "accordion-module-scss-module__GoEIuG__body-text-medium-16",
  "body-text-medium-18": "accordion-module-scss-module__GoEIuG__body-text-medium-18",
  "body-text-medium2-18": "accordion-module-scss-module__GoEIuG__body-text-medium2-18",
  "body-text2-14": "accordion-module-scss-module__GoEIuG__body-text2-14",
  "body-text2-16": "accordion-module-scss-module__GoEIuG__body-text2-16",
  "button-primary-text": "accordion-module-scss-module__GoEIuG__button-primary-text",
  "button-text": "accordion-module-scss-module__GoEIuG__button-text",
  "button2-text": "accordion-module-scss-module__GoEIuG__button2-text",
  "card-shadow": "accordion-module-scss-module__GoEIuG__card-shadow",
  "collapseBlock": "accordion-module-scss-module__GoEIuG__collapseBlock",
  "description": "accordion-module-scss-module__GoEIuG__description",
  "effect-menu": "accordion-module-scss-module__GoEIuG__effect-menu",
  "header-1": "accordion-module-scss-module__GoEIuG__header-1",
  "list": "accordion-module-scss-module__GoEIuG__list",
  "list__hoverIcon": "accordion-module-scss-module__GoEIuG__list__hoverIcon",
  "list__item": "accordion-module-scss-module__GoEIuG__list__item",
  "list__link": "accordion-module-scss-module__GoEIuG__list__link",
  "main-container": "accordion-module-scss-module__GoEIuG__main-container",
  "main-footer-container": "accordion-module-scss-module__GoEIuG__main-footer-container",
  "main-header-container": "accordion-module-scss-module__GoEIuG__main-header-container",
  "questionContainer": "accordion-module-scss-module__GoEIuG__questionContainer",
  "questionContainer__head": "accordion-module-scss-module__GoEIuG__questionContainer__head",
  "title": "accordion-module-scss-module__GoEIuG__title",
  "titleContainer": "accordion-module-scss-module__GoEIuG__titleContainer",
  "titleIconContainer": "accordion-module-scss-module__GoEIuG__titleIconContainer",
  "txt-12-bold": "accordion-module-scss-module__GoEIuG__txt-12-bold",
  "txt-14-bold": "accordion-module-scss-module__GoEIuG__txt-14-bold",
  "txt-14-bold-caps": "accordion-module-scss-module__GoEIuG__txt-14-bold-caps",
  "txt-14-med": "accordion-module-scss-module__GoEIuG__txt-14-med",
  "txt-16-bold": "accordion-module-scss-module__GoEIuG__txt-16-bold",
  "txt-16-med": "accordion-module-scss-module__GoEIuG__txt-16-med",
  "txt-18-bold": "accordion-module-scss-module__GoEIuG__txt-18-bold",
  "txt-18-medium": "accordion-module-scss-module__GoEIuG__txt-18-medium",
  "txt-18-medium-24": "accordion-module-scss-module__GoEIuG__txt-18-medium-24",
  "txt-24-semi": "accordion-module-scss-module__GoEIuG__txt-24-semi",
});
